export const unsavedChangesContainerSelectorDefault =
    '[class*="app-header "] ~ *, [class*="app-header "], .lc-modal, .snackbars, .MuiPickersPopper-root';
